module.exports = __webpack_public_path__ + "static/media/icon_mind.7f6b7c80.svg";